import { RiRobot2Line } from '@remixicon/react';

import { Text } from '@spotify-internal/encore-web';
import {
  type ToolGroupEntry,
  createToolExtension,
  getSubagentFallbackLabel,
  isSubagentTool,
  parseChildChatName,
  useChatRef,
} from '@spotify/plugin-confidence-chat-react';

import { confidenceChatPlugin } from '../plugin';

import styles from './CreateSubagentToolExtension.module.css';

const CreateSubagentToolRenderer = ({ entry }: { entry: ToolGroupEntry }) => {
  const childChatName = parseChildChatName(entry.result?.content);
  const { chat } = useChatRef({
    name: childChatName ?? '',
    skip: !childChatName,
  });
  const displayName = chat?.displayName;
  const label = displayName ?? getSubagentFallbackLabel(entry.tool);

  return (
    <div className={styles.root}>
      <RiRobot2Line size={14} className={styles.icon} />
      <Text variant="bodySmall" semanticColor="textSubdued">
        {label}
      </Text>
    </div>
  );
};

export const CreateSubagentToolExtension = confidenceChatPlugin.provide(
  createToolExtension({
    id: 'create-subagent',
    predicate: isSubagentTool,
    icon: RiRobot2Line,
    display: 'prominent',
    render: () => null,
    renderTool: entry => <CreateSubagentToolRenderer entry={entry} />,
  }),
);
